import {connect} from 'react-redux';
import AdminPageComponent from '../../Components/Backend';
import {withRouter} from 'react-router';
import {userLogOut} from '../../redux/actions/AuthActions';

const AdminContainer = connect (
    (state) => {
        return {
            isAuthenticated: state.authReducer.isAuthenticated,
            userRoles: state.authReducer.info.userRoles
        };
    },
    (dispatch) => {
        return {
            userLogOut: () => {
                dispatch(userLogOut());
            }
        };
    }
)(AdminPageComponent);

export default withRouter(AdminContainer);